import cloneDeep from 'lodash/cloneDeep'
import isEqual from 'lodash/isEqual'
import {
  GIFT_WITH_PURCHASE_DEFAULTS,
  GIFT_WITH_PURCHASE_SCHEMA_VERSION,
} from './giftWithPurchaseDefaults'
import { cloneGiftWithPurchaseConfig } from './giftWithPurchaseConfigHelpers'

const toIsoMaybe = (value) => {
  if (!value) {
    return null
  }

  if (typeof value.toDate === 'function') {
    return value.toDate().toISOString()
  }

  if (value instanceof Date) {
    return value.toISOString()
  }

  if (typeof value === 'string') {
    return value
  }

  return null
}

export const buildGiftWithPurchaseSavePayload = (draft) => ({
  schemaVersion: GIFT_WITH_PURCHASE_SCHEMA_VERSION,
  applyToOutlet: Boolean(draft.applyToOutlet),
  rewardGroups: (draft.rewardGroups || []).map((group) => ({
    id: group.id,
    name: group.name,
    sortOrder: group.sortOrder,
  })),
  tiers: (draft.tiers || []).map((tier) => ({
    id: tier.id,
    minAmount: tier.minAmount,
    sortOrder: tier.sortOrder,
    quotas: { ...(tier.quotas || {}) },
  })),
  packaging: {
    categorySelection: draft.packaging?.categorySelection
      ? cloneDeep(draft.packaging.categorySelection)
      : null,
    freeFromTierId: draft.packaging?.freeFromTierId || null,
  },
})

export const getGiftConfigCompareSnapshot = (config) => buildGiftWithPurchaseSavePayload(config)

export const areGiftConfigsEqual = (left, right) =>
  isEqual(getGiftConfigCompareSnapshot(left), getGiftConfigCompareSnapshot(right))

export const mapGiftWithPurchaseConfigFromDoc = (doc) => {
  if (!doc) {
    return null
  }

  const mapped = cloneGiftWithPurchaseConfig({
    schemaVersion:
      typeof doc.schemaVersion === 'number' ? doc.schemaVersion : GIFT_WITH_PURCHASE_SCHEMA_VERSION,
    applyToOutlet: Boolean(doc.applyToOutlet),
    rewardGroups: Array.isArray(doc.rewardGroups) ? doc.rewardGroups : [],
    tiers: Array.isArray(doc.tiers) ? doc.tiers : [],
    packaging: {
      categorySelection: doc.packaging?.categorySelection ?? null,
      freeFromTierId: doc.packaging?.freeFromTierId ?? null,
    },
  })

  return {
    ...mapped,
    createdAt: toIsoMaybe(doc.createdAt),
    updatedAt: toIsoMaybe(doc.updatedAt),
    updatedBy: doc.updatedBy || null,
  }
}

export const isUnsupportedGiftSchemaVersion = (config) =>
  typeof config?.schemaVersion === 'number' &&
  config.schemaVersion > GIFT_WITH_PURCHASE_SCHEMA_VERSION

export const createDefaultGiftConfigSnapshot = () =>
  cloneGiftWithPurchaseConfig(GIFT_WITH_PURCHASE_DEFAULTS)
